let id = 1;
export function getOverlayId() {
    return id++;
}
//# sourceMappingURL=overlay-id-generator.js.map